<template>
  <div class="pageheader">
    <h1 class="nav-title">
      <slot />
    </h1>
    <QNav class="topnav"/>
  </div>
</template>

<script>
export default {
  components: {
    QNav: () => import('./QNav.vue'),
  },
  setup() {
  },
};
</script>

<style lang="scss">
.pageheader {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4,1fr);
  grid-template-areas: 'title nav nav .';
  @media (max-width: $bp-md) {
    grid-gap: 1rem;
    grid-template-columns: 1fr;
    grid-template-areas: 'nav''title';
    // padding: 3rem 1rem;
  }
}
.nav-title {
  grid-area: title;
  text-align: left;
  @media (max-width: $bp-md) {
    text-align: center;
  }
}
.topnav {
  grid-area: nav;
}
</style>
